import React from 'react';
import {
  Box,
  Text,
  VStack,
  HStack,
  IconButton,
  Flex,
  Collapse,
} from '@chakra-ui/react';
import { EditIcon, DeleteIcon, ChevronDownIcon, ChevronRightIcon } from '@chakra-ui/icons';

const CategoryTree = ({ categories, expandedCategories, toggleCategory, onEdit, onDelete }) => {
  // Recursive function to render the category tree
  const renderCategoryTree = (categories, depth = 0) => {
    return categories.map((category) => (
      <Box
        key={category.id}
        p="2"
        borderRadius="md"
        _hover={{ bg: '#f9f9f9' }}
        bg={depth === 0 ? 'blue.50' : 'transparent'} // Style parent categories with background color
      >
        <Flex
          align="center"
          justify="space-between"
          cursor="pointer" // Make the whole row clickable
          onClick={() => toggleCategory(category.id)} // Toggle on click
        >
          <HStack spacing="2">
            {/* Expand/Collapse Icon */}
            {category.children?.length > 0 && (
              <IconButton
                size="sm"
                icon={expandedCategories[category.id] ? <ChevronDownIcon /> : <ChevronRightIcon />}
                variant="ghost"
                onClick={(e) => {
                  e.stopPropagation(); // Prevent row click
                  toggleCategory(category.id);
                }}
                aria-label="Toggle"
              />
            )}
            <Text fontWeight={depth === 0 ? 'bold' : 'normal'}>{category.name}</Text>
          </HStack>
          {/* Edit and Delete Actions */}
          <HStack spacing="1">
            <IconButton
              icon={<EditIcon />}
              size="sm"
              variant="outline"
              onClick={(e) => {
                e.stopPropagation(); // Prevent row click
                onEdit(category);
              }}
              aria-label="Edit"
            />
            <IconButton
              icon={<DeleteIcon />}
              size="sm"
              variant="outline"
              colorScheme="red"
              onClick={(e) => {
                e.stopPropagation(); // Prevent row click
                onDelete(category.id);
              }}
              aria-label="Delete"
            />
          </HStack>
        </Flex>

        {/* Render children if expanded */}
        {category.children?.length > 0 && (
          <Collapse in={expandedCategories[category.id]} animateOpacity>
            <VStack align="stretch" pl="4" borderLeft="1px solid #e2e8f0">
              {renderCategoryTree(category.children, depth + 1)}
            </VStack>
          </Collapse>
        )}
      </Box>
    ));
  };

  // Render the top-level tree
  return <>{renderCategoryTree(categories)}</>;
};

export default CategoryTree;
